export const PlusZoomIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.57422 1.33301V18.4816"
        stroke="#1e1e1e"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 9.90723H18.1486" stroke="#1e1e1e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CimPlusZoomIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
      <path stroke="#1E1E1E" strokeLinecap="round" d="M.5 4.642h8.4M4.758.5v8.4"></path>
    </svg>
  );
};
